module.exports = __webpack_public_path__ + "static/DH-773afe7e69004ea51c9648cbf5ad0c49.png";